import { useUpdatePiecesMutation } from '@api/piece';
import { PieceAction } from '@apiContract';

import { ActionComponentProps } from '../../index';
import { DialogQrCodeConfirmation } from '../DialogQrCodeConfirmation';

export const FinishDeliveryWithQrCode = ({ mailpieces, actionStarted, onActionFinish }: ActionComponentProps) => {
  const [updatePieces, { isLoading }] = useUpdatePiecesMutation();

  const confirmAction = async (qrCodeData: string) => {
    await updatePieces({
      pieces: mailpieces.map((piece) => ({ id: piece.id })),
      action: PieceAction.FinishDeliveryWithQrCode,
      qrCode: qrCodeData,
    }).unwrap();

    onActionFinish();
  };

  return (
    <DialogQrCodeConfirmation
      mailpieces={mailpieces}
      actionStarted={actionStarted}
      actionRequestInProgress={isLoading}
      onQrCodeRecognized={confirmAction}
      onActionFinish={onActionFinish}
    />
  );
};
